import { Padrao } from '../generic/padrao';

export class EndPais extends Padrao{

    override idTab = 164;

    nome: string;
    ibge: number;
    sigla: string;
}
